
import React from "react";
import { Button } from "@/components/ui/button";
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/components/ui/hover-card";
import { HelpCircle } from "lucide-react";

const TemplateVariableHelp: React.FC = () => {
  return (
    <HoverCard>
      <HoverCardTrigger asChild>
        <Button variant="ghost" size="sm" className="h-8 w-8 p-0">
          <HelpCircle className="h-4 w-4" />
        </Button>
      </HoverCardTrigger>
      <HoverCardContent className="w-80">
        <div className="space-y-2">
          <h4 className="font-medium">Template Variables</h4>
          <p className="text-sm text-muted-foreground">
            Use these variables to personalize your templates. Variables are
            replaced with actual data when the email is sent.
          </p>
          
          <div className="space-y-1">
            <h5 className="text-sm font-medium">Format</h5>
            <code className="text-xs bg-muted p-1 rounded">{`{{ variable.name }}`}</code>
          </div>
          
          <div className="space-y-1">
            <h5 className="text-sm font-medium">Common Variables</h5>
            <ul className="text-xs space-y-1">
              <li>
                <code className="bg-muted p-1 rounded">{`{{ email.subject }}`}</code> - Email subject
              </li>
              <li>
                <code className="bg-muted p-1 rounded">{`{{ email.sender.name }}`}</code> - Sender's name
              </li>
              <li>
                <code className="bg-muted p-1 rounded">{`{{ user.name }}`}</code> - Your name
              </li>
              <li>
                <code className="bg-muted p-1 rounded">{`{{ mailbox.name }}`}</code> - Mailbox name
              </li>
            </ul>
          </div>
        </div>
      </HoverCardContent>
    </HoverCard>
  );
};

export default TemplateVariableHelp;
